import DeleteShopArticleDigitalAssetByIdRequestModelBase from '../_generated/modelBases/delete-shop-article-digital-asset-by-id-request-model-base';

export default class DeleteShopArticleDigitalAssetByIdRequestModel extends DeleteShopArticleDigitalAssetByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
